module.exports = __webpack_public_path__ + "img/Arrow-L.d1d7ceb6.svg";